import { OpenStackRPC } from 'services/infra/openstack/OpenStackRPC';

type Params = {
    url: string;
    method?: HttpMethods;
    data?: Record<string, any>;
    options?: Record<string, any> & ExtendedXhrOptions;
    queryParams?: QureyParams;
};
type QureyParams = Partial<Record<string, number | string>>;
export type ExtendedXhrOptions = {
    onprogress?({ loaded, total }: ProgressEvent);
    saveAbortFunction?(func: () => void): void;
};

async function openstackRpcCall<T = any>({
    url,
    method = 'GET',
    data,
    options = {},
}: Params) {
    const response: any = await OpenStackRPC.call(url, data, options, method);
    return response.body as T;
}

export const OpenStackApiHelper = {
    openstackRpcCall,
};
